module.exports = __webpack_public_path__ + "static/media/magic-animated.466f87f2.gif";